import moment from 'moment';

class SMSearchHelper {

  static formatTitle(queries) {
    let texts = [];
    if (queries.eventType) {
      texts.push(I18n.t('service.event_type.' + queries.eventType));
    }
    if (queries.location) {
      texts.push(queries.location);
    }
    if (queries.startedAt && queries.endedAt) {
      const startedAtText = moment(queries.startedAt).utc().format('M月D日');
      const endedAtText = moment(queries.endedAt).utc().format('M月D日');
      texts.push([startedAtText, endedAtText].join('〜'));
    }
    if (queries.capacity) {
      if (queries.capacity == 1) {
        texts.push(I18n.t('service.label_000104'));
      } else {
        texts.push(queries.capacity + I18n.t('service.capacity.suffix'));
      }
    }
    if (queries.keyword) {
      texts.push(queries.keyword);
    }
    return texts.join('・');
  }

  static featureAmenityList(eventType, amenityList) {
    let list = [];
    switch (eventType) {
      case 'party':
        list = ['drinking', 'kitchen_facilities', 'market'];
        break;
      case 'event':
        list = ['drinking', 'kitchen_facilities'];
        break;
      case 'class':
      case 'meeting':
        list = ['wifi', 'whiteboard', 'projector'];
        break;
      case 'office':
        list = ['power_equipment', 'wifi', 'printer'];
        break;
      case 'photo_shoot':
        list = ['photography_equipment', 'lighting_equipment', 'parking'];
        break;
      case 'film_shoot':
        list = ['film_equipment', 'lighting_equipment', 'parking'];
        break;
      case 'performance':
        list = ['sound_system', 'mirrors', 'parking'];
        break;
      case 'sports':
        list = ['lockers', 'changing_room', 'showers'];
        break;
      case 'wedding':
        list = ['parking'];
        break;
      case 'studio':
        list = ['parking'];
        break;
      case 'stay':
        break;
      default:
    }
    let amenities = [];
    list.forEach((name)=>{
      amenityList.some((amenity)=>{
        if (name == amenity.name) {
          amenities.push(amenity);
          return true;
        }
      });
    });
    return amenities;
  }

}
export default SMSearchHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMSearchHelper.js